module.exports = __webpack_public_path__ + "media/images/logo_mailer-de20ee68daa3bc50b693ca1117aed7df.png";